import React, {Component} from "react";
import * as PropTypes from "prop-types";
import "./conversationItem.scss";
import {Spinner} from "../../../../components";
import SocialReplyItem from "./SocialReplyItem";


export default class SocialReplyList extends Component {

  static propTypes = {
    depth: PropTypes.number.isRequired,
    index: PropTypes.number.isRequired,

    // The children to display
    children: PropTypes.array.isRequired,
    offsetOdd: PropTypes.bool,

    loadOlder: PropTypes.func,
    loadNewer: PropTypes.func,

    isLoadingOlder: PropTypes.bool,
    isLoadingNewer: PropTypes.bool,

    ascendingReplyPath: PropTypes.array,
    postInQuestion: PropTypes.any,

    grabScrollPosition: PropTypes.any,
    restoreScrollPosition: PropTypes.any,
    onApprove: PropTypes.func,
    onReject: PropTypes.func,
    onDelete: PropTypes.func,
    onChildUpdate: PropTypes.func,
    scheduledResponses: PropTypes.array,

    hideWorkflowTask: PropTypes.bool,
  };


  static defaultProps = {
    children: [],
    ascendingReplyPath: [],
    postInQuestion: undefined,
    isLoadingOlder: false,
    isLoadingNewer: false,
    hideWorkflowTask: false
  };


  renderOlderReplies = (loadOlder, isLoadingOlder) => {
    if (!loadOlder) return undefined;
    return this.renderMoreReplies(loadOlder, isLoadingOlder, "View previous replies");
  };

  renderNewerReplies = (loadNewer, isLoadingNewer) => {
    if (!loadNewer) return undefined;
    return this.renderMoreReplies(loadNewer, isLoadingNewer, "View new replies");
  };

  renderMoreReplies = (loadFunc, isLoading, text) => {
    if (!loadFunc) return undefined;
    const spinnerOrLink = isLoading
      ? <Spinner size="sm" className="pt-2" timeout={0} center/>
      : <a tabIndex="0" className="post-conversation-load-more" onClick={loadFunc}>{text}</a>;

    return (
      <div className="post-conversation-load-more-container">
        {spinnerOrLink}
      </div>
    );
  };

  renderChildren = (props) => {
    const {
      children,
      offsetOdd,
      depth,
      index,
      ascendingReplyPath,
      postInQuestion,
      grabScrollPosition,
      restoreScrollPosition,
      scheduledResponses,
      ...rest
    } = props;

    if (!children) return undefined;
    return children.map((child, i) => {
      return <SocialReplyItem
        {...rest}
        postInQuestion={postInQuestion}
        ascendingReplyPath={ascendingReplyPath}
        key={child.postId || child.socialPublishingId}
        index={depth <= 0 ? i + (offsetOdd ? 1 : 0): index}
        depth={depth + 1}
        grabScrollPosition={grabScrollPosition}
        restoreScrollPosition={restoreScrollPosition}
        item={child}
        onApprove={this.props.onApprove}
        onReject={this.props.onReject}
        onDelete={this.props.onDelete}
        onUpdate={this.props.onChildUpdate}
        hideWorkflowTask={this.props.hideWorkflowTask}
      
      />;
    });
  };

  render() {
    const { loadOlder, loadNewer, isLoadingOlder, isLoadingNewer } = this.props;
    return (
      <div>
        <span>
          {this.renderOlderReplies(loadOlder, isLoadingOlder)}
          {this.renderChildren(this.props)}
          {this.renderNewerReplies(loadNewer, isLoadingNewer)}
        </span>
      </div>
    )
  }

}
